module.exports = __webpack_public_path__ + "static/instagram-feed-9eaa379599cfcea71845bb7cc0e51587.jpg";